import { isNotNullish } from './check/isNotNullish';

export const objectFilterNullishValues = <T extends object>(o: T) =>
  Object.fromEntries(Object.entries(o).filter(([, v]) => isNotNullish(v)));
